import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { SortableTable } from 'common/components/SortableTable';
import { getSponsors } from './actions/getSponsors';

// Item 5 — admin sponsor list with entitlement counts and their candidates.
const TABLE_HEADERS = [
  { id: 'name', align: 'left', numeric: false, label: 'SPONSOR' },
  { id: 'email', align: 'left', numeric: false, label: 'EMAIL' },
  { id: 'engTokens', align: 'right', numeric: true, label: 'ENG TOKENS' },
  { id: 'techTokens', align: 'right', numeric: true, label: 'TECH TOKENS' },
  { id: 'candidateCount', align: 'right', numeric: true, label: 'CANDIDATES' },
  { id: 'view', align: 'right', numeric: false, label: '' },
];

function createData(row, onView) {
  return [
    { id: 'name', value: row.name },
    { id: 'email', value: row.email },
    { id: 'engTokens', value: row.engTokens, align: 'right' },
    { id: 'techTokens', value: row.techTokens, align: 'right' },
    { id: 'candidateCount', value: row.candidateCount, align: 'right' },
    {
      id: 'view',
      align: 'right',
      value: (
        <Button size="small" variant="outlined" disabled={!row.candidateCount} onClick={() => onView(row)}>
          Candidates
        </Button>
      ),
    },
  ];
}

const Sponsors = () => {
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState(null);

  const handleView = (row) => setSelected(row);

  useEffect(() => {
    let mounted = true;
    getSponsors().then((sponsors) => {
      if (mounted) setRows(sponsors.map((s) => createData(s, handleView)));
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Grid item xs={12}>
      <Typography variant="h5" style={{ marginTop: 16, marginBottom: 8 }}>
        Sponsors
      </Typography>
      <SortableTable
        name="admin-sponsors"
        headers={TABLE_HEADERS}
        rows={rows}
        defaultSortColumnIndex={0}
        searchable
        searchColumnName="name"
      />
      <Dialog open={!!selected} onClose={() => setSelected(null)} maxWidth="sm" fullWidth>
        <DialogTitle>{selected ? `${selected.name} — candidates` : ''}</DialogTitle>
        <DialogContent dividers>
          <List dense>
            {(selected && selected.candidates ? selected.candidates : []).map((c) => (
              <ListItem key={c.id}>
                <ListItemText primary={c.name || '(no name)'} secondary={c.crn} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelected(null)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Sponsors;
